const outlineLesson = (title = 'Introdução') => ({ title, description: '', durationMinutes: 30, materials: [], tasks: [], quiz: null });

export const parseCourseOutline = (text = '') => {
  const modules = [];
  String(text).split(/\r?\n/).forEach((line) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    if (/^[-•]/.test(trimmed)) {
      const title = trimmed.replace(/^[-•]\s*/, '').trim();
      if (!title) return;
      if (!modules.length) modules.push({ title: 'Módulo 1', description: '', lessons: [] });
      modules[modules.length - 1].lessons.push(outlineLesson(title));
    } else {
      modules.push({ title: trimmed, description: '', lessons: [] });
    }
  });
  return modules.map(module => ({ ...module, lessons: module.lessons.length ? module.lessons : [outlineLesson()] }));
};

// New content must receive new identities on the server, including nested questions.
export const duplicateCourseContent = (value) => {
  if (Array.isArray(value)) return value.map(duplicateCourseContent);
  if (!value || typeof value !== 'object') return value;
  return Object.fromEntries(Object.entries(value)
    .filter(([key]) => key !== 'id' && key !== 'order')
    .map(([key, nested]) => [key, duplicateCourseContent(nested)]));
};

export const normalizeCourseOrder = (form) => ({
  ...form,
  modules: (form.modules || []).map((module, index) => ({
    ...module, order: index + 1,
    lessons: (module.lessons || []).map((lesson, lessonIndex) => ({ ...lesson, order: lessonIndex + 1 })),
  })),
});

export const getCourseReview = (form) => {
  const issues = [];
  if (!String(form.title || '').trim()) issues.push({ panel: 'overview', message: 'Informe o título do curso.' });
  if (!form.modules?.length) issues.push({ panel: 'content', message: 'Adicione ao menos um módulo com uma aula.' });
  (form.modules || []).forEach((module, index) => {
    if (!String(module.title || '').trim()) issues.push({ panel: 'content', message: `Dê um nome ao módulo ${index + 1}.` });
    if (!module.lessons?.length) issues.push({ panel: 'content', message: `Adicione uma aula ao módulo ${index + 1}.` });
    (module.lessons || []).forEach((lesson, lessonIndex) => {
      if (!String(lesson.title || '').trim()) issues.push({ panel: 'content', message: `Dê um nome à aula ${index + 1}.${lessonIndex + 1}.` });
      if (!Number.isFinite(Number(lesson.durationMinutes)) || Number(lesson.durationMinutes) <= 0) {
        issues.push({ panel: 'content', message: `Informe a duração da aula ${index + 1}.${lessonIndex + 1}.` });
      }
    });
  });
  if (!String(form.certificateConfig?.signerName || '').trim()) issues.push({ panel: 'certificate', message: 'Informe quem assina o certificado.' });
  return issues;
};

export const getResumeLessonId = (lessons = [], completedIds = []) => {
  const completed = new Set(completedIds.map(String));
  return (lessons.find(lesson => !completed.has(String(lesson.id))) || lessons[0])?.id ?? null;
};
